import {BaseModel} from '../base.model';
import {JsonProperty} from '../json-map.util';
import {LessonModel} from '../lesson/lesson.model';
import {ProblemModel} from '../problem/problem.model';

class ExerciseModel extends BaseModel {

  title: string = undefined as any;
  description: string = undefined as any;
  subject: string = undefined as any;
  accuracyGoal: number = undefined as any;
  pacingGoal: number = undefined as any;
  introCopy: string = undefined as any;
  completeCopy: string = undefined as any;
  videoLink: string = undefined as any;
  showOpenAnswerEnabled = undefined;
  openAnswerPrompt = undefined;

  @JsonProperty({ clazz: ProblemModel })
  problems: ProblemModel[] = [];

  @JsonProperty({ clazz: LessonModel })
  lesson: LessonModel = undefined as any;

  parse(json: Object) {
    if (json) {
      super.parse(json);
    }

    return this;
  }
}

export { ExerciseModel };
